/**
 * Re-confirmarea parolei master pentru acțiuni sensibile (descărcarea frazei
 * de recuperare, ștergerea unui spațiu). Parola nu pleacă la server: derivăm
 * cheia, o comparăm în timp constant cu cea din sesiune și întoarcem doar
 * `auth_hash`, pe care serverul îl verifică la rândul lui.
 */
import { authApi } from '@/api/auth';
import {
  base64ToBytes,
  bytesToBase64,
  computeAuthHash,
  deriveMasterKey,
  kdfParamsFromServer,
} from '@/crypto/sodium';
import { useAuthStore } from '@/stores/auth';

/** `null` dacă parola e greșită sau sesiunea nu are cheie. */
export async function reauthHash(password: string): Promise<string | null> {
  const { masterKey } = useAuthStore.getState();
  if (!masterKey) return null;
  const kdf = await authApi.getOwnKdf();
  const derived = await deriveMasterKey(
    password,
    base64ToBytes(kdf.kdf_salt),
    kdfParamsFromServer(kdf.kdf_params),
  );
  try {
    let diff = derived.length ^ masterKey.length;
    for (let i = 0; i < derived.length; i++) diff |= derived[i] ^ (masterKey[i] ?? 0);
    if (diff !== 0) return null;
    return bytesToBase64(await computeAuthHash(derived));
  } finally {
    derived.fill(0);
  }
}
